import $ from "../libs/jquery-3.3.1.min.js"
import mqtt from "mqtt";

// Constructor
export class MystMQTT {

  constructor(baseStationRfid) {
    this.currentQuestBaseStationRFID = baseStationRfid;

    this.mostRecentVisitId = null

    this.onConnected = () => {
    };

    this.onDisconnected = () => {
    };

    this.onMessage = () => {
    };

  }

  connect({url, username, password, topic, stationFilter = false}) {
    return new Promise((resolve, reject) => {

      if (this.mqttClient) {
        this.mqttClient.end(true);
      }

      this.stationFilter = stationFilter
      this.currentTopic = "";

      const mqttSettings = {
        username: username,
        password: password,
        clientId: 'limacharlie_' + Math.random().toString(16).substr(2, 8),
        rejectUnauthorized: false,
        reconnectPeriod: 1000,
        connectTimeout: 2 * 1000,
        keepalive: 5,
      };

      // Init MystMQTT connection
      this.mqttClient = mqtt.connect(url, mqttSettings);

      // On connect
      this.mqttClient.on("connect", () => {
        console.log("Connected to MystMQTT broker.")
        if (topic) this.subscribe(topic);
        this.onConnected();
        resolve();
      });

      // Subscribe to topics
      this.mqttClient.on("error", (e) => {
        console.error(e)
        reject(e);
      });

      // Listen to messages
      this.mqttClient.on("message", (topic, message) => {

        // message is Buffer
        const messageString = message.toString();

        // Convert to JSON
        const messageData = JSON.parse(messageString);

        if (messageData && messageData.visit_id) {
          this.mostRecentVisitId = messageData.visit_id;
        }

        // Dispatch
        // console.log(topic, messageData);
        if (this.stationFilter === false || this.stationFilter === messageData.last_station) {
          this.onMessage(messageData)
        }
      });

      this.mqttClient.on("close", () => {
        console.log("Disconnected from MystMQTT broker.")
        this.onDisconnected();
      });

    });
  }

  subscribe(topic) {
    if (topic === undefined) topic = $(`[name="topic-select"]`).val();

    if (this.mqttClient && this.mqttClient.connected) {
      this.mqttClient.subscribe(topic, (err) => {
        if (err) console.log("Error subscribing.", err.message)
      });
      this.currentTopic = topic
    } else {
      console.log("Error subscribing. Not connected.")
    }
  }

  unsubscribe(topic) {
    if (this.mqttClient && this.mqttClient.connected) {
      this.mqttClient.unsubscribe(topic, (err) => {
        if (err) console.log("Error unsubscribing.", err.message)
      });
      this.currentTopic = topic
    }
  }

  unsubscribeCurrentTopic() {
    this.unsubscribe(this.currentTopic);
    this.currentTopic = "";
  }

  updateBaseStationState(state) {
    this.updateRFID(this.currentQuestBaseStationRFID, state);
  }

  updateRFID(rfid, state) {
    // Update the base station value using MQTT
    if (this.mostRecentVisitId) {
      const updateData = {
        "progress": [{
          "station": rfid,
          "state": state
        }]
      }
      console.log(`(MQTT) Update visit ${this.mostRecentVisitId}. Set ${rfid} to  ${state}.`)
      this.mqttClient.publish(`visit/${this.mostRecentVisitId}`, JSON.stringify(updateData))
    } else {
      // There have been an error, we should not be here
      console.warn(`(MQTT) Couldn't update using MQTT. The mostRecentVisitId object is empty.`)
    }
  }

  setLight(preset) {
    this.updateRFIDLight(this.currentQuestBaseStationRFID, preset);
  }

  updateRFIDLight(rfid, preset) {
    // Update the light preset
    const updateData = {"preset": preset}
    const rfidWithoutPrefix = rfid.replace("RFID-", "")
    console.log(`(MQTT) Update light. Set ${rfid} to ${preset} using reader/light/${rfidWithoutPrefix}`)
    this.mqttClient.publish(`reader/light/${rfidWithoutPrefix}`, JSON.stringify(updateData))
  }

}
